import { useState, useEffect, useCallback, useRef } from "react";
import "../vendor/vendorList.css";
import "../common/Util.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { ReactComponent as AddIc } from "../../assets/svg/add_icon.svg";
import { ReactComponent as ImportIc } from "../../assets/svg/import_ic.svg";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as EmailView } from "../../assets/svg/email_view_ic.svg";
import { ReactComponent as ListView } from "../../assets/svg/list_view_ic.svg";
import { ReactComponent as SelectGrid } from "../../assets/svg/seelct_grid_ic.svg";
import { ReactComponent as SelectList } from "../../assets/svg/select_list_ic.svg";
import { ReactComponent as LocationIc } from "../../assets/svg/location_ic.svg";
import { ReactComponent as PhoneIc } from "../../assets/svg/phone_ic.svg";
import { ReactComponent as MailIC } from "../../assets/svg/mail_ic.svg";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as ThreeDotIC } from "../../assets/svg/three-dot-ic.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import { ReactComponent as CloseIc } from "../../assets/svg/close-modal.svg";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import { ReactComponent as FileAddIc } from "../../assets/svg/file_add.svg";
import { ReactComponent as PlusImageIc } from "../../assets/svg/plus_image.svg";
import profileIc from "../../assets/png/profile-ic.png";
import { Dropdown, Modal, Toast, ToastContainer } from "react-bootstrap";
import SearchableDropdown from "../common/commonDropDown";
import ReactPaginate from "react-paginate";
import {
  deleteVendorApi,
  getVendorListApi,
  getVendorStagesApi,
  updateStageApi,
  downloadVendorTemplateApi,
  uploadVendorExcelApi,
} from "./vendor_api";
import Loader from "../common/loader";
import LoaderModal from "../common/loader";
import { useNavigate } from "react-router-dom";
import DeleteModal from "../common/deleteModel";
import DateRangePicker from "../common/dateRange";
import "react-datepicker/dist/react-datepicker.css";
import { Sidebar } from "../common/Sidebar";
import { Navbar } from "../common/Navbar";
import { ReactComponent as EditIc } from "../../assets/svg/edit_ic.svg";
import { ReactComponent as DeleteIc } from "../../assets/svg/delete_ic.svg";
import { Check } from "lucide-react";
import { useGlobal } from "../../GlobalContext";
import ProfileImageModal from "../common/common-preview";
function VendorListingPage() {
  // location
  const navigate = useNavigate();
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const { rolePermissionList, userType } = useGlobal();
  function checkPermission(menuName, permission) {
    return rolePermissionList.findIndex(
      (element) =>
        element["name"] === menuName &&
        element["menu_permission"] === true &&
        element[permission] === true,
    ) > -1
      ? true
      : false;
  }
  // variable initial
  const isFirstRender = useRef(true);
  const iconStyle = { width: "16px", height: "16px" };
  const [search, setSearch] = useState("");
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const [sortbyOpen, setSortbyOpen] = useState(false);
  const [stageSelect, setStageSelect] = useState({
    value: "",
    label: "All",
  });
  const [stageOpen, setStageOpen] = useState(false);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [gradeSelect, setGradeSelect] = useState(null);
  const [industrySelect, setIndustrySelect] = useState(null);
  const [citySelect, setCitySelect] = useState(null);
  const [active, setActive] = useState("list");
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [deleteId, setDeleteId] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [stageOption, setStageOption] = useState([]);
  const [stageListOption, setListStageOption] = useState([]);
  const [sortByOption, setSortByOption] = useState([
    {
      value: "created asc",
      label: "Created (Oldest)",
    },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ]);
  const [vendorList, setVendorList] = useState([]);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(null);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenDelete, setIsOpenDelete] = useState(false);
  
  const [showImportModal, setShowImportModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const handleSelectExcelFileClick = () => {
    if (fileInputRef.current) {
        fileInputRef.current.click();
    }
  };

  const handleExcelFileUploaded = (event) => {
    const file = event.target.files?.[0];
    if (file) {
        setSelectedFile(file);
    }
    if (event.target) {
        event.target.value = "";
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    const file = e.dataTransfer.files?.[0];
    if (file) {
        const fileExtension = file.name.split('.').pop().toLowerCase();
        if (fileExtension === 'xlsx' || fileExtension === 'xls') {
            setSelectedFile(file);
        } else {
            alert("Only Excel file format (.xlsx, .xls) is supported.");
        }
    }
  };

  const handleDownloadTemplate = async () => {
    try {
      setIsLoading(true);
      const response = await downloadVendorTemplateApi();
      if (response && response.data && response.data.success) {
        const link = document.createElement("a");
        link.href = response.data.url;
        link.setAttribute("download", "Vendor_upload_template.xlsx");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setSnackbarMessage(response.data.message || "Template downloaded successfully.");
        setSnackbarStatus(true);
      } else {
        setSnackbarMessage(response?.data?.message || "Failed to download template.");
        setSnackbarStatus(false);
      }
    } catch (error) {
      setSnackbarMessage("Error downloading template.");
      setSnackbarStatus(false);
    } finally {
      setIsLoading(false);
      handleSnackbarShow();
    }
  };

  const handleUploadClick = async () => {
    if (!selectedFile) {
      setSnackbarMessage("Please select a file to upload.");
      setSnackbarStatus(false);
      handleSnackbarShow();
      return;
    }

    try {
      setIsLoading(true);
      const base64String = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(selectedFile);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
      });

      const bodyData = { upload_file: base64String };
      const response = await uploadVendorExcelApi(bodyData);

      if (response && response.data && response.data.success) {
        setSnackbarMessage(response.data.message || "Excel uploaded successfully.");
        setSnackbarStatus(true);
        getVendorList();
      } else {
        setSnackbarMessage(response?.data?.message || "Failed to upload excel.");
        setSnackbarStatus(false);
        if (response?.data?.url) {
          const link = document.createElement("a");
          link.href = response.data.url;
          link.setAttribute("download", "Vendor_Upload_Error_report.xlsx");
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }
    } catch (error) {
      setSnackbarMessage("Error uploading file.");
      setSnackbarStatus(false);
    } finally {
      setIsLoading(false);
      handleSnackbarShow();
      setShowImportModal(false);
      setSelectedFile(null);
    }
  };
  // handle
  const handleSelectGradle = (option) => {
    console.log("Selected option:", option);
    setGradeSelect(option);
  };
  const handleSelectIndustry = (option) => {
    console.log("Selected option:", option);
    setIndustrySelect(option);
  };
  const handleSelectCity = (option) => {
    console.log("Selected option:", option);
    setCitySelect(option);
  };
  const handleClearGradle = () => {
    setGradeSelect(null);
  };
  const handleClearIndustry = () => {
    setIndustrySelect(null);
  };
  const handleClearCity = () => {
    setCitySelect(null);
  };
  const handlePageClick = useCallback((event) => {
    setItemOffset(event.selected);
  }, []);

  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);
  };
  // useEffect

  useEffect(() => {
    getVendorStages();
  }, []);

  useEffect(() => {
    // if (isFirstRender.current) {
    //   isFirstRender.current = false; // skip first run
    //   return;
    // }
    getVendorList();
  }, [
    itemsPerPage,
    itemOffset,
    search,
    selectedSortby,
    stageSelect,
    citySelect,
    industrySelect,
    gradeSelect,
  ]);

  useEffect(() => {
    if (deleteId !== null) {
      setIsOpenDelete(true);
    }
  }, [deleteId]);
  // Api

  const getVendorStages = async () => {
    try {
      const response = await getVendorStagesApi();
      if (response.data.success === true) {
        setStageOption([
          { value: "", label: "All" },
          ...response.data.suggestionlist,
        ]);

        setListStageOption(response.data.suggestionlist);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const updateStage = async (id, value) => {
    setIsLoading(true);
    const bodyData = {
      stage_id: value,
    };
    try {
      const response = await updateStageApi(id, bodyData);
      console.log("response....", response);
      if (response.data.success === true) {
        getVendorList();
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const deleteVendor = async () => {
    try {
      const response = await deleteVendorApi(deleteId);
      console.log("response....", response);
      setSnackbarMessage(response.data.message);
      setSnackbarStatus(response.data.success);
      handleSnackbarShow();
      if (response.data.success === true) {
        getVendorList();

        setDeleteId(null);
        setIsOpenDelete(false);
      }
    } catch (err) {
      const message =
        err?.response?.data?.message || err?.message || "Something went wrong";
      const success = err?.response?.data?.success ?? false;
      setSnackbarMessage(message);
      setSnackbarStatus(success);
      handleSnackbarShow();
      console.error("Delete vendor error:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const getVendorList = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      stage_id: stageSelect?.value ?? "",
      industry: industrySelect?.value ?? "",
      grade_id: gradeSelect?.value ?? "",
      billing_city: citySelect?.value ?? "",
      from_date: "",
      to_date: "",
      sort_field: field,
      sort_dir: dir,
    };
    try {
      const response = await getVendorListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setVendorList(response.data.vendors);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  };
  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");
  return (
    <>
      <ProfileImageModal
        show={showProfilePopup}
        onClose={() => setShowProfilePopup(false)}
        imageUrl={selectedProfile}
      />
      <LoaderModal show={isLoading} />
      <DeleteModal
        title={"vendor"}
        isOpen={isOpenDelete}
        onClose={() => setIsOpenDelete(false)}
        onDelete={deleteVendor}
      />
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Vendors" />

        {/* Main Content */}
        <div className="rounded-4 flex-grow-1  ">
          {" "}
          <Navbar pageTitle="Vendors" />
          <div className="bg-half-white p-2">
            <div className="bg-white rounded-4 p-4">
              {" "}
              {/* First Row */}
              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* Left: Heading */}
                <div className="my-heading fs-24 fw-600">
                  Vendors - {totalCount}
                </div>

                {/* Right: Controls */}
                <div className="d-flex flex-wrap gap-3">
                  {/* Search */}
                  <div className="search-wrapper d-flex align-items-center gap-2 px-3 py-2">
                    <SearchIc />
                    <input
                      type="text"
                      placeholder="Search"
                      className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                      value={search || ""}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>

                  {/* Add New Vendor */}
                  {checkPermission("Vendors", "create_permission") && (
                    <div
                      className="cursor-pointer my-box d-flex align-items-center justify-content-center gap-2 px-3"
                      onClick={() => navigate("/vendor/create")}
                      style={{
                        height: "40px", // Adjust button height if needed
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center" }}>
                        <AddIc style={{ width: "16px", height: "16px" }} />{" "}
                        {/* ✅ Smaller Icon */}
                      </div>

                      <div
                        className="fs-12 fw-600" // ✅ Reduced text size
                        style={{ lineHeight: "16px" }}
                      >
                        New Vendor
                      </div>
                    </div>
                  )}

                  {/* Import */}
                  <div
                    className="my-import d-flex align-items-center justify-content-center gap-2"
                    style={{ height: "40px", cursor: "pointer" }} // Optional: consistent height
                    onClick={() => setShowImportModal(true)}
                  >
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <ImportIc style={{ width: "16px", height: "16px" }} />{" "}
 
                    </div>

                    <div
                      className="fs-12 fw-600"
                      style={{ lineHeight: "16px" }} // Ensures proper vertical centering
                    >
                      Import
                    </div>
                  </div>
                </div>
              </div>
              {/* Second Row */}
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex justify-content-start gap-3">
                  <div onClick={(e) => e.stopPropagation()}>
                    <Dropdown
                      show={sortbyOpen}
                      onToggle={(nextShow) => setSortbyOpen(nextShow)}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-sort"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "8px 16px",
                          backgroundColor: "white",
                          transition: "all 0.2s ease-in-out",
                          outline: "none",
                          boxShadow: "none",
                          minWidth: "200px",
                          gap: "12px",
                        }}
                        title={selectedSortby.label}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#6c5ce7";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 0.2rem rgba(108, 92, 231, 0.15)";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#EBEBEB";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.currentTarget) {
                            e.currentTarget.style.borderColor = "#d0d0d0";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.currentTarget) {
                            e.currentTarget.style.borderColor = "#EBEBEB";
                          }
                        }}
                      >
                        {/* Left: "Sort by" label */}
                        <span
                          className="fs-12 fw-400 textGrey"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Sort by :
                        </span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center gap-2 flex-grow-1 justify-content-between">
                          <span
                            className="dropdown-text fs-13 fw-500 textcolor"
                            style={{
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                            }}
                          >
                            {selectedSortby.label}
                          </span>

                          <span
                            className="dropdown-toggle-arrow textPurple"
                            style={{
                              transition: "transform 0.2s ease-in-out",
                              transform: sortbyOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "12px",
                          border: "none",
                          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                          marginTop: "8px",
                          padding: "8px",
                        }}
                      >
                        {sortByOption.map((option) => (
                          <Dropdown.Item
                            className="d-flex justify-content-between align-items-center"
                            key={option.value}
                            onClick={(e) => {
                              e.stopPropagation();
                              setSelectedSortBy(option);
                            }}
                            active={selectedSortby.value === option.value}
                            style={{
                              borderRadius: "6px",
                              padding: "10px 12px",
                              margin: "2px 0",
                              transition: "all 0.15s ease-in-out",
                              backgroundColor:
                                selectedSortby.value === option.value
                                  ? "#f0ebff"
                                  : "transparent",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#212129",
                            }}
                            onMouseEnter={(e) => {
                              if (selectedSortby.value !== option.value) {
                                e.currentTarget.style.backgroundColor =
                                  "#f8f9fa";
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                selectedSortby.value === option.value
                                  ? "#f0ebff"
                                  : "transparent";
                            }}
                          >
                            <span>{option.label}</span>
                            {selectedSortby.value === option.value && (
                              <Check
                                size={16}
                                color="#6c5ce7"
                                strokeWidth={2.5}
                              />
                            )}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <Dropdown
                      show={stageOpen}
                      onToggle={(nextShow) => setStageOpen(nextShow)}
                    >
                      <Dropdown.Toggle
                        variant="light"
                        id="dropdown-stage"
                        className="d-flex align-items-center justify-content-between"
                        style={{
                          borderRadius: "12px",
                          border: "1px solid #EBEBEB",
                          padding: "8px 16px",
                          backgroundColor: "white",
                          transition: "all 0.2s ease-in-out",
                          outline: "none",
                          boxShadow: "none",
                          minWidth: "160px",
                          gap: "12px",
                        }}
                        onFocus={(e) => {
                          e.currentTarget.style.borderColor = "#6c5ce7";
                          e.currentTarget.style.boxShadow =
                            "0 0 0 0.2rem rgba(108, 92, 231, 0.15)";
                        }}
                        onBlur={(e) => {
                          e.currentTarget.style.borderColor = "#EBEBEB";
                          e.currentTarget.style.boxShadow = "none";
                        }}
                        onMouseEnter={(e) => {
                          if (document.activeElement !== e.currentTarget) {
                            e.currentTarget.style.borderColor = "#d0d0d0";
                          }
                        }}
                        onMouseLeave={(e) => {
                          if (document.activeElement !== e.currentTarget) {
                            e.currentTarget.style.borderColor = "#EBEBEB";
                          }
                        }}
                      >
                        {/* Left: "Stage" label */}
                        <span
                          className="fs-12 fw-400 textGrey"
                          style={{ whiteSpace: "nowrap" }}
                        >
                          Stage :
                        </span>

                        {/* Right: Selected + arrow */}
                        <span className="d-flex align-items-center gap-2 flex-grow-1 justify-content-between">
                          <span
                            className="dropdown-text fs-13 fw-500"
                            style={{
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              color: stageSelect?.label ? "#212129" : "#888888",
                            }}
                          >
                            {stageSelect?.label || "Select"}
                          </span>

                          <span
                            className="dropdown-toggle-arrow textPurple"
                            style={{
                              transition: "transform 0.2s ease-in-out",
                              transform: stageOpen
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <DownArrow />
                          </span>
                        </span>
                      </Dropdown.Toggle>

                      <Dropdown.Menu
                        style={{
                          backgroundColor: "white",
                          borderRadius: "12px",
                          border: "none",
                          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                          marginTop: "8px",
                          padding: "8px",
                        }}
                      >
                        {stageOption.map((option) => (
                          <Dropdown.Item
                            className="d-flex justify-content-between align-items-center"
                            key={option.value}
                            onClick={() => setStageSelect(option)}
                            active={stageSelect?.value === option.value}
                            style={{
                              borderRadius: "6px",
                              padding: "10px 12px",
                              margin: "2px 0",
                              transition: "all 0.15s ease-in-out",
                              backgroundColor:
                                stageSelect?.value === option.value
                                  ? "#f0ebff"
                                  : "transparent",
                              cursor: "pointer",
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#212129",
                            }}
                            onMouseEnter={(e) => {
                              if (stageSelect?.value !== option.value) {
                                e.currentTarget.style.backgroundColor =
                                  "#f8f9fa";
                              }
                            }}
                            onMouseLeave={(e) => {
                              e.currentTarget.style.backgroundColor =
                                stageSelect?.value === option.value
                                  ? "#f0ebff"
                                  : "transparent";
                            }}
                          >
                            <span>{option.label}</span>
                            {stageSelect?.value === option.value && (
                              <Check
                                size={16}
                                color="#6c5ce7"
                                strokeWidth={2.5}
                              />
                            )}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_industry`}
                      placeholder="Industry"
                      value={industrySelect}
                      onSelect={handleSelectIndustry}
                      handleClear={handleClearIndustry}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${apiUrl}get_grade`}
                      placeholder="Grade"
                      value={gradeSelect}
                      onSelect={handleSelectGradle}
                      handleClear={handleClearGradle}
                    />
                  </div>
                  <div>
                    <SearchableDropdown
                      apiUrl={`${adminUrl}get_city`}
                      placeholder="City"
                      value={citySelect}
                      onSelect={handleSelectCity}
                      handleClear={handleClearCity}
                    />
                  </div>
                  {/* <div
                  className="d-flex align-items-center px-1"
                  style={{
                    borderRadius: "12px",
                    border: "1px solid #EBEBEB",

                    backgroundColor: "white",
                  }}
                >
                  <span className="fs-12 fw-400 textGrey">Date :</span>
                  <span className="dropdown-text textPurple">
                    {" "}
                    <DateRangePicker onChange={handleDateChange} />
                  </span>
                </div>
                 */}
                </div>
                <div
                  className="rounded-4 toggleBg d-flex mt-2"
                  style={{
                    width: "80px",
                    height: "32px",
                    backgroundColor: "#f1f3f6", // toggle background
                    padding: "4px",
                    gap: "4px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    onClick={() => setActive("list")}
                    className={`d-flex align-items-center justify-content-center rounded-3  ${
                      active === "list" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "list" ? (
                      <ListView style={iconStyle} />
                    ) : (
                      <SelectList style={iconStyle} />
                    )}
                  </div>

                  <div
                    onClick={() => setActive("grid")}
                    className={`d-flex align-items-center justify-content-center rounded-3 ${
                      active === "grid" ? "bg-primary1" : ""
                    }`}
                    style={{
                      width: "36px",
                      height: "24px",
                      cursor: "pointer",
                    }}
                  >
                    {active === "grid" ? (
                      <SelectGrid style={iconStyle} />
                    ) : (
                      <EmailView style={iconStyle} />
                    )}
                  </div>
                </div>
              </div>
            </div>
            {active === "list" && (
              <div className="bg-white rounded-4 mt-3 w-100 p-3">
                <div
                  style={{
                    display: "flex",
                    flex: "10",
                    paddingLeft: "16px",
                    paddingRight: "16px",
                    paddingTop: "16px",
                    height: "40px",
                    backgroundColor: "#F2F2F2",
                  }}
                  className="head3 w-100 justify-content-center align-items-center"
                >
                  {/* <input
                                type="checkbox"
                                checked={isChecked}
                                onChange={handleChange}
                                style={{ marginRight: "8px", marginBottom: "14px" }}
                              /> */}
                  <p
                    style={{ width: "127px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Name
                  </p>
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Location
                  </p>
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Industry
                  </p>{" "}
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Phone No
                  </p>{" "}
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Email
                  </p>{" "}
                  <p
                    style={{ width: "160px", flex: "1" }}
                    className="fs-13 fw-700 textcolor"
                  >
                    Stage
                  </p>{" "}
                </div>
                <div>
                  {(vendorList ?? []).map((item, index) => (
                    <div
                      style={{
                        display: "flex",
                        flex: "10",
                        paddingLeft: "16px",
                        paddingRight: "16px",

                        backgroundColor:
                          hoveredIndex === index ? "#FAFAFA" : "#FFFFFF",
                        borderBottom: "1px solid #D4DDE7",
                        cursor: "pointer",
                        height: "44px",
                      }}
                      onClick={() => {
                        if (checkPermission("Vendors", "view_permission")) {
                          navigate("/viewVendor", {
                            state: { id: item.id },
                          });
                        }
                      }}
                      onMouseEnter={() => setHoveredIndex(index)}
                      onMouseLeave={() => setHoveredIndex(null)}
                      className="head3 w-100 justify-content-center align-items-center"
                    >
                      {" "}
                      {/* <input
                                    type="checkbox"
                                    checked={isChecked}
                                    onChange={handleChange}
                                    style={{ marginRight: "8px", marginBottom: "0px" }}
                                  /> */}
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.name}
                      >
                        <img
                          key={index}
                          src={
                            item.image && item.image.trim() !== ""
                              ? item.image
                              : profileIc
                          }
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProfile(
                              item.image && item.image.trim() !== ""
                                ? item.image
                                : profileIc,
                            );
                            setShowProfilePopup(true);
                          }}
                          alt="Profile"
                          className="avatar-item me-1 ms-0"
                        />

                        {item.name ?? "-"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.city}
                      >
                        {item.city ?? "-"}
                      </p>
                      <div
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "flex-start",
                        }}
                        title={item.industry}
                      >
                        {item.industry ?? "-"}
                      </div>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.mobile_number}
                      >
                        {item.mobile_number && item.mobile_number.trim() !== ""
                          ? item.mobile_number
                          : "-"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.email}
                      >
                        {item.email && item.email.trim() !== ""
                          ? item.email
                          : "-"}
                      </p>
                      <p
                        className="fs-13 fw-500 textcolor"
                        style={{
                          flex: "1",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          marginTop: "16px",
                        }}
                        title={item.stage}
                      >
                        {item.stage ?? "-"}
                      </p>
                      {hoveredIndex === index && (
                        <div
                          style={{
                            position: "absolute",
                            // top: "50%",
                            right: "35px",
                            // transform: "translate(-50%, -50%)",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              alignItems: "center",
                            }}
                          >
                            {checkPermission("Vendors", "edit_permission") && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  navigate("/vendor/create", {
                                    state: { id: item.id },
                                  });
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <EditIc />{" "}
                              </div>
                            )}
                            <span style={{ marginLeft: "16px" }}></span>
                            {checkPermission(
                              "Vendors",
                              "delete_permission",
                            ) && (
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setDeleteId(item.id);
                                }}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  width: "28px",
                                  height: "28px",
                                  borderRadius: "100px",
                                  background: "#FFFFFF",
                                  cursor: "pointer",
                                  border: "0.8px solid #E5E5E5",
                                }}
                              >
                                <DeleteIc />{" "}
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            )}
            {active === "grid" &&
              vendorList.map((vendor, index) => (
                <div
                  key={index}
                  className="d-flex align-items-center justify-content-between   business-card w-100 p-3 mt-3"
                  style={{ cursor: "pointer" }}
                  onClick={() => {
                    if (checkPermission("Vendors", "view_permission")) {
                      navigate("/viewVendor", {
                        state: { id: vendor.id },
                      });
                    }
                  }}
                >
                  <div className="d-flex flex-grow-1  w-25">
                    <div className="profile-wrapper">
                      <img
                        src={
                          vendor.image && vendor.image.trim() !== ""
                            ? vendor.image
                            : profileIc
                        }
                        alt="Profile"
                        className="profile-img"
                      />
                      <div className="profile-badge fs-11">
                        {vendor.grade_name ?? "-"}
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-2 ps-3">
                      <div className="textcolor fs-16 fw-400 ">
                        {vendor.name ?? "-"}
                      </div>
                      <div className="d-flex gap-2  align-items-center">
                        <LocationIc />{" "}
                        <span className="textGrey fs-12 fw-400">
                          {vendor.city ?? "-"}
                        </span>{" "}
                        <span
                          style={{
                            width: "4px",
                            height: "4px",
                            backgroundColor: "#D9D9D9",
                            borderRadius: "50%",

                            display: "inline-block",
                          }}
                        ></span>
                        <div className="rounded-4 backgroundBlue px-2 py-1 textBlue fs-11 fw-500">
                          {vendor.industry ?? "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="d-flex flex-column gap-2 ps-3 flex-grow-1  w-25">
                    <div className="textltcolor fs-13 fw-400 ">
                      <MailIC /> {vendor.email ?? "-"}
                    </div>
                    <div className="textltcolor fs-13 fw-400 ">
                      <PhoneIc /> {vendor.mobile_number ?? "-"}
                    </div>
                  </div>
                  <div className="d-flex flex-row flex-grow-1 align-items-end justify-content-end gap-2 ps-3  w-25">
                    <div onClick={(e) => e.stopPropagation()}>
                      <Dropdown>
                        <Dropdown.Toggle
                          variant="light"
                          id="dropdown-vendor-stage"
                          className="d-flex align-items-center justify-content-between backgroundltprimary rounded-5"
                          style={{
                            padding: "6px 12px",
                            border: "1px solid transparent",
                            transition: "all 0.2s ease-in-out",
                            outline: "none",
                            boxShadow: "none",
                          }}
                          onFocus={(e) => {
                            e.currentTarget.style.borderColor = "#6c5ce7";
                            e.currentTarget.style.boxShadow =
                              "0 0 0 0.2rem rgba(108, 92, 231, 0.15)";
                          }}
                          onBlur={(e) => {
                            e.currentTarget.style.borderColor = "transparent";
                            e.currentTarget.style.boxShadow = "none";
                          }}
                          onMouseEnter={(e) => {
                            if (document.activeElement !== e.currentTarget) {
                              e.currentTarget.style.backgroundColor = "#e8e5ff";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (document.activeElement !== e.currentTarget) {
                              e.currentTarget.style.backgroundColor = "";
                            }
                          }}
                        >
                          <span className="d-flex align-items-center px-1 gap-2">
                            <span
                              className="backgroundPrimary"
                              style={{
                                width: "10px",
                                height: "10px",
                                borderRadius: "3px",
                                display: "inline-block",
                              }}
                            ></span>

                            <span className="dropdown-text textcolor fs-13 fw-500">
                              {vendor.stage ?? "-"}
                            </span>

                            <span className="dropdown-toggle-arrow">
                              <DownArrowIc />
                            </span>
                          </span>
                        </Dropdown.Toggle>

                        <Dropdown.Menu
                          style={{
                            backgroundColor: "white",
                            borderRadius: "12px",
                            border: "none",
                            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                            marginTop: "8px",
                            padding: "8px",
                          }}
                        >
                          {stageListOption.map((option) => (
                            <Dropdown.Item
                              className="d-flex justify-content-between align-items-center"
                              key={option.value}
                              onClick={() =>
                                updateStage(vendor.id, option.value)
                              }
                              active={vendor.stage === option.label}
                              style={{
                                borderRadius: "6px",
                                padding: "10px 12px",
                                margin: "2px 0",
                                transition: "all 0.15s ease-in-out",
                                backgroundColor:
                                  vendor.stage === option.label
                                    ? "#f0ebff"
                                    : "transparent",
                                cursor: "pointer",
                                fontSize: "14px",
                                fontWeight: "500",
                                color: "#212129",
                              }}
                              onMouseEnter={(e) => {
                                if (vendor.stage !== option.label) {
                                  e.currentTarget.style.backgroundColor =
                                    "#f8f9fa";
                                }
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.backgroundColor =
                                  vendor.stage === option.label
                                    ? "#f0ebff"
                                    : "transparent";
                              }}
                            >
                              <span>{option.label}</span>
                              {vendor.stage === option.label && (
                                <Check
                                  size={16}
                                  color="#6c5ce7"
                                  strokeWidth={2.5}
                                />
                              )}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <div onClick={(e) => e.stopPropagation()}>
                      {(checkPermission("Vendors", "edit_permission") ||
                        checkPermission("Vendors", "delete_permission")) && (
                        <Dropdown>
                          <Dropdown.Toggle
                            variant="light"
                            id="dropdown-vendor-actions"
                            className="d-flex align-items-center justify-content-between rounded-5 bg-white"
                            style={{
                              width: "36px",
                              height: "36px",
                              border: "1px solid #EBEBEB",
                              transition: "all 0.2s ease-in-out",
                              outline: "none",
                              boxShadow: "none",
                            }}
                            onFocus={(e) => {
                              e.currentTarget.style.borderColor = "#6c5ce7";
                              e.currentTarget.style.boxShadow =
                                "0 0 0 0.2rem rgba(108, 92, 231, 0.15)";
                            }}
                            onBlur={(e) => {
                              e.currentTarget.style.borderColor = "#EBEBEB";
                              e.currentTarget.style.boxShadow = "none";
                            }}
                            onMouseEnter={(e) => {
                              if (document.activeElement !== e.currentTarget) {
                                e.currentTarget.style.borderColor = "#d0d0d0";
                                e.currentTarget.style.backgroundColor =
                                  "#f8f9fa";
                              }
                            }}
                            onMouseLeave={(e) => {
                              if (document.activeElement !== e.currentTarget) {
                                e.currentTarget.style.borderColor = "#EBEBEB";
                                e.currentTarget.style.backgroundColor = "white";
                              }
                            }}
                          >
                            <span className="d-flex align-items-center px-1 gap-2">
                              <ThreeDotIC />
                            </span>
                          </Dropdown.Toggle>

                          <Dropdown.Menu
                            style={{
                              backgroundColor: "white",
                              borderRadius: "12px",
                              border: "none",
                              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                              marginTop: "8px",
                              padding: "8px",
                            }}
                          >
                            {checkPermission("Vendors", "edit_permission") && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  navigate("/vendor/create", {
                                    state: { id: vendor.id },
                                  });
                                }}
                                style={{
                                  borderRadius: "6px",
                                  padding: "10px 12px",
                                  margin: "2px 0",
                                  transition: "all 0.15s ease-in-out",
                                }}
                              >
                                Edit
                              </Dropdown.Item>
                            )}
                            {checkPermission(
                              "Vendors",
                              "delete_permission",
                            ) && (
                              <Dropdown.Item
                                className="fs-14 fw-500 textcolor"
                                onClick={() => {
                                  setDeleteId(vendor.id);
                                }}
                                style={{
                                  borderRadius: "6px",
                                  padding: "10px 12px",
                                  margin: "2px 0",
                                  transition: "all 0.15s ease-in-out",
                                }}
                              >
                                Delete
                              </Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            <div className="py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
              <Dropdown>
                <span className="pagination-color">
                  Records per page: &nbsp;
                </span>
                <Dropdown.Toggle
                  id="dropdown-pagination"
                  className="bg-transparent pagination-color border-0 custom-dropdown-toggle p-0"
                  style={{
                    outline: "none",
                    boxShadow: "none",
                  }}
                >
                  <span
                    className="bg-white textcolor no-of-rows rounded-3 px-2 py-2"
                    style={{
                      border: "1px solid #EBEBEB",
                      transition: "all 0.2s ease-in-out",
                      display: "inline-block",
                    }}
                  >
                    {itemsPerPage} <DownArrowIc />
                  </span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  className="my-2"
                  style={{ minWidth: "unset", width: "30%" }}
                >
                  {[10, 25, 50, 75, 100].map((size) => (
                    <Dropdown.Item
                      key={size}
                      onClick={() => {
                        setItemsPerPage(size);
                      }}
                      active={itemsPerPage === size}
                      className="text-center"
                    >
                      {size}
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>

              <div className="d-flex align-items-center gap-2">
                <ReactPaginate
                  previousLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <LarIc />
                    </div>
                  }
                  nextLabel={
                    <div
                      className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                      style={{
                        width: "32px",
                        height: "32px",
                      }}
                    >
                      <RarIc />
                    </div>
                  }
                  breakLabel={"..."}
                  pageCount={pageCount + 1}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handlePageClick}
                  containerClassName={"pagination"}
                  activeClassName={"active"}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Hidden Input field for Excel Upload */}
      <input
          type="file"
          ref={fileInputRef}
          style={{ display: 'none' }}
          accept=".xlsx, .xls"
          onChange={handleExcelFileUploaded}
      />

      {/* Import Bulk Excel Modal */}
      <Modal
          show={showImportModal}
          onHide={() => {
              setShowImportModal(false);
              setSelectedFile(null);
          }}
          centered
          className="import-file-modal"
      >
          <Modal.Header className="border-0 p-4 pb-0 position-relative">
              <div className="w-100">
                  <h3 className="modal-title fw-bold fs-24 mb-1">Import File</h3>
                  <p className="text-muted fs-14 mb-0">Choose an Excel file and import all the data from that.</p>
              </div>
              <div
                  className="close-btn-custom-import"
                  onClick={() => {
                      setShowImportModal(false);
                      setSelectedFile(null);
                  }}
              >
                  <CloseIc style={{ width: "16px" }} />
              </div>
          </Modal.Header>
          <Modal.Body className="p-4">
              <div 
                  className="upload-area-custom d-flex flex-column align-items-center justify-content-center" 
                  onClick={handleSelectExcelFileClick} 
                  style={{ cursor: 'pointer' }}
                  onDragOver={handleDragOver}
                  onDragLeave={handleDragLeave}
                  onDrop={handleDrop}
              >
                  {selectedFile ? (
                      <>
                          <div className="upload-icon-circle mb-3" style={{ backgroundColor: "#EEF2FF" }}>
                              <FileAddIc style={{ width: "24px", height: "24px", color: "#4F46E5" }} />
                          </div>
                          <h5 className="fs-16 fw-700 mb-1 text-primary-blue">File Selected</h5>
                          <p className="text-muted fs-13 mb-3 fw-500">{selectedFile.name} ({(selectedFile.size / 1024).toFixed(1)} KB)</p>
                          <button className="btn-select-file text-nowrap" style={{ minWidth: "max-content" }} onClick={(e) => { e.stopPropagation(); setSelectedFile(null); }}>
                              Remove File
                          </button>
                      </>
                  ) : (
                      <>
                          <div className="upload-icon-circle mb-3">
                              <FileAddIc style={{ width: "24px", height: "24px" }} />
                          </div>
                          <h5 className="fs-16 fw-700 mb-1">Drag and drop your files</h5>
                          <p className="text-muted fs-12 mb-3">Only Excel file format (Max. Size 5MB)</p>
                          <button className="btn-select-file d-flex align-items-center justify-content-center gap-2 text-nowrap" style={{ minWidth: "max-content" }} onClick={(e) => { e.stopPropagation(); handleSelectExcelFileClick(); }}>
                              <PlusImageIc style={{ width: "14px", height: "14px" }} /> Select File
                          </button>
                      </>
                  )}
              </div>
          </Modal.Body>
          <Modal.Footer className="border-0 p-4 pt-0 d-flex justify-content-between">
              <button className="btn-template-custom" onClick={handleDownloadTemplate}>
                  <DownloadIc style={{ width: "16px", height: "16px" }} /> Template
              </button>
              <div className="d-flex gap-3">
                  <button
                      className="btn-cancel-custom-modal"
                      onClick={() => {
                          setShowImportModal(false);
                          setSelectedFile(null);
                      }}
                  >
                      Cancel
                  </button>
                  <button 
                      className="btn-upload-custom" 
                      onClick={handleUploadClick}
                      disabled={!selectedFile}
                  >
                      Upload
                  </button>
              </div>
          </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end">
        <Toast
          className="d-inline-block m-1"
          bg={snackbarStatus === true ? "success" : "danger"}
          show={showSnackbar}
          onClose={handleSnackbarClose}
          delay={3000}
          autohide
        >
          <Toast.Body style={{ color: "#ffffff" }}>
            {snackbarMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
}

export default VendorListingPage;
